module.exports = __webpack_public_path__ + "media/images/modules/publisher/tabs/live--active-d2eeafc24f6f165c813aef535ec40e19.png";